import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
//
import {
  DashboardOverviewPage,
  CityCreatePage,
  CityEditPage,
  CityDetailPage,
  CityListPage,
  PostListPage,
  PostCreatePage,
  PostEditPage,
  LoginPage,
  NewPasswordPage,
  Page403,
  Page404,
  Page500,
  PermissionDeniedPage,
  ResetPasswordPage,
  VerifyCodePage,
  DesignationinassociationListPage,
  DesignationinassociationCreatePage,
  DesignationinassociationEditPage,
  MemberListPage,
  MemberCreatePage,
  MemberEditPage,
  MemberDetailPage,
  UploadDocCreateEditPage,
} from './elements';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [{ element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true }],
    },

    // Auth
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          element: <CompactLayout />,
          children: [
            { path: 'reset-password', element: <ResetPasswordPage /> },
            { path: 'new-password', element: <NewPasswordPage /> },
            { path: 'verify', element: <VerifyCodePage /> },
          ],
        },
      ],
    },

    // Association dashboard only (AF-06: template demo routes removed)
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'overview', element: <DashboardOverviewPage /> },
        {
          path: 'member',
          children: [
            { element: <Navigate to="/dashboard/member/list" replace />, index: true },
            { path: 'list', element: <MemberListPage /> },
            { path: 'new', element: <MemberCreatePage /> },
            { path: 'edit/:id', element: <MemberEditPage /> },
            { path: 'detail/:id', element: <MemberDetailPage /> },
          ],
        },
        {
          path: 'upload-document',
          children: [{ path: 'update', element: <UploadDocCreateEditPage /> }],
        },
        {
          path: 'city',
          children: [
            { element: <Navigate to="/dashboard/city/list" replace />, index: true },
            { path: 'list', element: <CityListPage /> },
            { path: 'new', element: <CityCreatePage /> },
            { path: 'edit/:id', element: <CityEditPage /> },
            { path: ':id', element: <CityDetailPage /> },
          ],
        },
        {
          path: 'post',
          children: [
            { element: <Navigate to="/dashboard/post/list" replace />, index: true },
            { path: 'list', element: <PostListPage /> },
            { path: 'new', element: <PostCreatePage /> },
            { path: 'edit/:id', element: <PostEditPage /> },
          ],
        },
        {
          path: 'designationinassociation',
          children: [
            {
              element: <Navigate to="/dashboard/designationinassociation/list" replace />,
              index: true,
            },
            { path: 'list', element: <DesignationinassociationListPage /> },
            { path: 'new', element: <DesignationinassociationCreatePage /> },
            { path: 'edit/:id', element: <DesignationinassociationEditPage /> },
          ],
        },
        { path: 'permission-denied', element: <PermissionDeniedPage /> },
      ],
    },

    {
      element: <CompactLayout />,
      children: [
        { path: '500', element: <Page500 /> },
        { path: '404', element: <Page404 /> },
        { path: '403', element: <Page403 /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
